var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5239 8.02711L11.8989 2.27711C11.7808 2.1983 11.642 2.15625 11.5 2.15625C11.358 2.15625 11.2192 2.1983 11.1011 2.27711L2.47609 8.02711C2.37763 8.0928 2.29692 8.18179 2.24113 8.28617C2.18533 8.39056 2.15617 8.50711 2.15625 8.62547V17.9692C2.15625 18.3505 2.3077 18.7161 2.57728 18.9857C2.84687 19.2553 3.2125 19.4067 3.59375 19.4067H19.4062C19.7875 19.4067 20.1531 19.2553 20.4227 18.9857C20.6923 18.7161 20.8438 18.3505 20.8438 17.9692V8.62547C20.8438 8.50711 20.8147 8.39056 20.7589 8.28617C20.7031 8.18179 20.6224 8.0928 20.5239 8.02711ZM11.5 3.73887L18.8591 8.64523L12.8396 12.938H10.1622L4.1427 8.64523L11.5 3.73887ZM3.59375 17.9692V10.0207L9.51445 14.2434C9.63636 14.3305 9.78242 14.3773 9.93223 14.3773H13.0678C13.2176 14.3773 13.3636 14.3305 13.4855 14.2434L19.4062 10.0207V17.9692H3.59375Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEmail);
export default __webpack_public_path__ + "static/media/openEmail.82e942ef622715ec76fe4ceac243b272.svg";
export { ForwardRef as ReactComponent };